import React, { useMemo } from "react";
import { Button, Spinner } from "reactstrap";

const fmtMoney = (n) => {
  const x = Number(n || 0);
  return x.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const RecouvrementDetailsDrawer = ({
  isOpen,
  onClose,
  dateISO,
  items,
  loading,
  onExport,
  exporting,
}) => {
  const total = useMemo(() => {
    return (items || []).reduce((acc, x) => acc + Number(x.montantRegle || 0), 0);
  }, [items]);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(15, 23, 42, 0.45)",
          zIndex: 1050,
        }}
      />

      {/* Drawer */}
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100vh",
          width: "min(520px, 92vw)",
          background: "#fff",
          zIndex: 1051,
          boxShadow: "0 20px 60px rgba(2, 6, 23, 0.25)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "16px 16px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>Détails des chèques</div>
            <div style={{ fontSize: 18, fontWeight: 900, color: "#0f172a" }}>
              Échéance: {dateISO || "—"}
            </div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>
              Total: <strong>{fmtMoney(total)} MAD</strong> · {items?.length || 0} chèque(s)
            </div>
          </div>

          <div className="d-flex gap-2">
            <Button
              color="success"
              onClick={onExport}
              disabled={exporting}
              style={{ borderRadius: 12 }}
            >
              {exporting ? (
                <>
                  <Spinner size="sm" className="me-2" /> Export…
                </>
              ) : (
                "Exporter"
              )}
            </Button>

            <Button color="light" onClick={onClose} style={{ borderRadius: 12 }}>
              Fermer
            </Button>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: 16, overflow: "auto" }}>
          {loading ? (
            <div className="py-4 text-center" style={{ color: "#6b7280" }}>
              <Spinner size="sm" className="me-2" /> Chargement…
            </div>
          ) : !items?.length ? (
            <div className="py-4 text-center" style={{ color: "#6b7280" }}>
              Aucun chèque pour cette date.
            </div>
          ) : (
            <div style={{ display: "grid", gap: 12 }}>
              {items.map((x, idx) => (
                <div
                  key={x.id || idx}
                  style={{
                    border: "1px solid #e5e7eb",
                    borderRadius: 14,
                    padding: 12,
                    background: "#ffffff",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontWeight: 900, color: "#0f172a", fontSize: 14, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {x.nomClient || "Client"}
                      </div>
                      <div style={{ fontSize: 12, color: "#6b7280" }}>
                        {x.codeClient ? `Code: ${x.codeClient}` : ""}{" "}
                        {x.banque ? `· Banque: ${x.banque}` : ""}
                      </div>
                    </div>

                    <div style={{ textAlign: "right" }}>
                      <div style={{ fontWeight: 900, color: "#065f46", fontSize: 14 }}>
                        {fmtMoney(x.montantRegle)} MAD
                      </div>
                      <div style={{ fontSize: 12, color: "#6b7280" }}>
                        N° chèque: <strong>{x.numeroCheque || "—"}</strong>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      marginTop: 10,
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: 8,
                      fontSize: 12,
                      color: "#334155",
                    }}
                  >
                    <div>
                      <div style={{ color: "#6b7280" }}>Factures</div>
                      <div style={{ fontWeight: 800 }}>{x.numFactures || "—"}</div>
                    </div>
                    <div>
                      <div style={{ color: "#6b7280" }}>Bon Livraison</div>
                      <div style={{ fontWeight: 800 }}>{x.numBonLivraisons || "—"}</div>
                    </div>

                    <div>
                      <div style={{ color: "#6b7280" }}>Référence paiement</div>
                      <div style={{ fontWeight: 800 }}>{x.referencePaiement || x.reference || "—"}</div>
                    </div>
                    <div>
                      <div style={{ color: "#6b7280" }}>Statut</div>
                      <div style={{ fontWeight: 800 }}>{x.statut || "—"}</div>
                    </div>
                  </div>

                  {x.commentaire ? (
                    <div style={{ marginTop: 10, fontSize: 12, color: "#6b7280" }}>
                      {x.commentaire}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RecouvrementDetailsDrawer;